// extracted by mini-css-extract-plugin
export default {"CompleteMenu":"style_CompleteMenu__8w909"};